enum TransactionVerb {
  Bought = 'bought',
  Renewed = 'renewed'
}

export default TransactionVerb;
